import lightFormat from 'date-fns/lightFormat'

export function dayId(day: Date) {
  return lightFormat(day, 'yyyy-MM-dd')
}
